
/**
 *      Application router for Query Manager UI
 *
 *      @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *      Created in 2015
 *      Modified on 8/16/2021 by Nhi Cmerek
 */


/*jshint strict:false */
/*global Backbone, $, App */

var ApplicationRouter = Backbone.Router.extend({

    initialize: function( el ) {
        this.el = el;
        this.searchView = new ContentView( { template: '#search-template' } );
        this.advancedSearchView = new ContentView( { template: '#advanced-search-template' } );
        this.notFoundView = new ContentView( { template: '#not-found' } );
        this.pageView = new ContentView( { template: '#page-template' } );
    },

    routes: {

        // Default Insight search
        "search(/)": "search",

        // Alias project search
        "search/:alias(/)": "search",

        // Alias project single record
        "view/:alias/:type/:id(/)": "recordWithAlias",

        // Advanced search
        "advanced-search(:filters)": "advancedSearch",
        "advanced-search(/:query)": "advancedSearch",
        "advanced-search/:alias/(:query)": "advancedSearchWithAlias",

        // Catch all other pages
        "*else": "notFound"
    },

    /**
     * Switch current view to another view
     * @param view
     */
    switchView: function( view ) {
        if ( this.currentView ) {
            // Detach the old view
            this.currentView.remove();
        }
        // Move the view element into the DOM (replacing the old content)
        this.el.html(view.el);
        // Render view after it is in the DOM (styles are applied)
        view.render();
        this.currentView = view;
    },

    /**
     * Un-highlight active entries in the navigation bar (only style guide uses it)
     */
    removeActiveEntries: function() {
        // Unmark all entries
        $('ul.nav.navbar-nav li').removeClass('active');
    },

    /**
     * Full search page with keyword search.
     * @api {get} /search/[:alias][/?q=:query][&type=:type][&filters=:filters][&page=:page][&pagesize=:pagesize] Basic search
     * @apiName search
     * @apiParam {string} [alias] The alias against which the search will be performed. If undefined, alias comes from a separate configuration file where alias is determined by the hostname of the requesting page or application.
     * @apiParam {string} [query] The search query to search against. The query "all" or "any" returns all results if search type is "exact" or default.
     * @apiParam {string} [type] One or more comma separated document types against which the search will be performed.
     * @apiParam {string} [filters] One or more semicolon separated filters that will be applied to the search. A filter consists of a field name, an operator, and a value separated by a pipe. Complete list of options for operators is: eq, =, lt, <, gt, >, ne, !=, sw, ^=, btwn, between, re, regex, regexp, notregexp. All other operators are ignored.
     * @apiParam {string} [page] The page number of the search results. Invalid inputs are ignored and the page number is set to 1. If omitted, the page is set to 1.
     * @apiParam {string} [pagesize] The number of search results returned per page. The default value is 20. The maximum value is 300. If less than 1 is specified, the pagesize is set to 20. If more than 300 is specified, pagesize is set to 300.
     * @apiParam {string} [view] Search results view type. Available options are "tile" or default. Default view is the list view.
     * @apiGroup Search
     * @apiVersion 4.13.6
     * @apiDescription Search page
     * @apiSuccess {HTML} response Full search page including search results, filters, search history and trends with header and footer. The search page calls Query Manager Web to generate sections of the page body and Shared Styles to generate the header and footer.
     */
    search: function( ) {
        //console.log("in search " + alias)

        this.switchView( this.searchView );

        if ( ! App.globalState.isDev ) {
            setHeader( "Search" );
            getUser();

        }
        // Display search page UI

        //console.log("Get search UI " + App.globalState.alias);
        var d = new Date();
        //console.log(d.getTime());
        getSearchUI( d );

    },


    /**
     * Full record viewer page. The order of page can be defined in the data model ui_order top-level property.
     * @api {get} /view/:alias/:type/:id Record Viewer
     * @apiName view
     * @apiParam {string} alias The document record alias.
     * @apiParam {string} type The document record type.
     * @apiParam {string} id Record id.
     * @apiGroup View
     * @apiVersion 4.10.0
     * @apiDescription Record Viewer page
     * @apiSuccess {HTML} response Full Record Viewer page with header and footer. The page calls Query Manager Web to generate sections of the page body, Data Model Registry to get the data model, and Shared Styles to generate the header and footer. For all record types, the page shows the title, version history (if found), metadata panels, and linked records. Graphs (tree viewers), risk matrix and additional tables are shown if they are defined in the data model for the record type.
     */
    recordWithAlias: function( alias, type, id ){

        if ( alias && type && id ) {

            App.globalState.alias = alias;
            App.globalState.documentType = type;
            App.globalState.documentId = id;
            App.globalState.viewType = "ui";

            if ( ! App.globalState.isDev ) {
                setRecordHeader( type );
                getUser();

                // If there is an existing query, set it in the header search bar
                if ( App && App.globalState && App.globalState.query ) {
                    $( 'input[name="basic-search"]').val( App.globalState.query );
                }
            }

            this.switchView( this.pageView );
            getRecordUI( alias, type, id, "ui", null );

        } else {
            this.switchView( this.notFoundView );
        }

    },


    /**
     * Advanced search page
     */
    advancedSearch: function( ) {

        this.switchView( this.advancedSearchView );
        // hideFooter();
        setHeader("Advanced Search");

        // set the width of the left header
        if ( $('.header-left') && $('.header-left').length === 1 ) {
            $( '.header-left')[0].setAttribute('style', 'width:100%;');
        }

        // Hide basic header controls
        hideSearchBox();

        // Display search page UI
        getAdvancedSearchUI( );

    },

    /**
     * Advanced search page with field-level search.
     * @api {get} /advanced-search/:alias[/?q=:query][&type=:type][&filters=:filters][&nosearch=:nosearch] Field-level search
     * @apiName searchAdvanced
     * @apiParam {string} [alias] The alias against which the search will be performed. If undefined, alias comes from a separate configuration file where alias is determined by the hostname of the requesting page or application.
     * @apiParam {string} [query] The search query to search against. The query "all" or "any" returns all results if search type is "exact" or default.
     * @apiParam {string} [type] One or more comma separated document types against which the search will be performed.
     * @apiParam {string} [filters] One or more semicolon separated filters that will be applied to the search. A filter consists of a field name, an operator, and a value separated by a pipe. Complete list of options for operators is: eq, =, lt, <, gt, >, ne, !=, sw, ^=, btwn, between, re, regex, regexp, notregexp. All other operators are ignored.
     * @apiParam {string} [nosearch] Optional flag ("true" or "false") that indicates whether to display search results or not. If nosearch is "true", the page does not render search results, but instead sents the response back to the page that referred it. If the flag anything other than "true", search results will be rendered as HTML in the Advanced Search page.
     * @apiGroup Search
     * @apiVersion 4.10.0
     * @apiDescription Advanced Search page
     * @apiSuccess {HTML} response Full or partial advanced search page that can include search menu, search results, filters, page header and footer. The page calls Query Manager Web to generate sections of the page body and Shared Styles to generate the header and footer.
     */
    advancedSearchWithAlias: function( alias ) {
        if(alias) {
            App.globalState.alias = alias;
            //console.log("advancedSearchWithAlias: " + App.globalState.alias)
        }
        this.switchView( this.advancedSearchView );
        // hideFooter();
        setHeader("Advanced Search");
        // set the width of the left header
        if ( $('.header-left') && $('.header-left').length === 1 ) {
            $( '.header-left')[0].setAttribute('style', 'width:100%;');
        }

        // Hide basic header controls
        hideSearchBox();

        // Display search page UI
        getAdvancedSearchUI( );

    },

    /**
     * Page Not Found
     * @api {get} /* All other routes
     * @apiName notFound
     * @apiGroup Other
     * @apiVersion 4.10.0
     * @apiDescription Not Found page
     * @apiSuccess {HTML} response Full page with header and footer that displays the message that page is not found. The page calls Shared Styles to generate the header and footer.
     */
    notFound: function() {
        this.switchView( this.notFoundView );

        this.removeActiveEntries();
        if ( ! App.globalState.isDev ) {
            setHeader("");
        }
        if ( ! App.globalState.isDev ) {
            setFooter();
        }
    }

});